import Moment from 'moment';

export const getYear = (date) => {

    return Moment(date).format('YYYY')
}